import Administration from "./administration";
import manageCompanies from "./manageCompanies";
import Dashboard from "./dashboard";
import Settings from "./settings";
import Policies from "./policies";
import AlertConsole from "./alertconsole";
import Endpoints from "./endpoints";
import PolicyChangeChecklist from "./policychangechecklist";
import Policy from "./policy";

const administrationBaseLink = "company-overview";
const manageCompaniesBaseLink = "company-list";
const dashboardBaseLink = "company-overview";
const hashInspectionBaseLink = "allhashes";
const policyBaseLink = "policy-review";

export default [
  {
    path: "/",
    redirect: "/dashboard/company-overview",
  },
  {
    path: "/dashboard",
    name: "/dashboard",
    component: () => import("@/views/pages/Dashboard/Index.vue"),
    meta: {
      title: "dashboard",
      breadcrumb: dashboardBaseLink,
    },
    children: [...Dashboard],
  },
  {
    path: "/manage-companies",
    name: "/manage-companies",
    meta: {
      title: "manage-companies",
      breadcrumb: manageCompaniesBaseLink,
    },
    component: () => import("@/views/pages/Iframe.vue"),
    children: [...manageCompanies],
  },
  {
    path: "/administration",
    name: "/administration",
    meta: {
      title: "administration",
      breadcrumb: administrationBaseLink,
    },
    component: () => import("@/views/pages/Administration.vue"),
    children: [...Administration],
  },
  {
    name: "hashInspection",
    path: "/hash-inspection",
    component: () => import("@/views/pages/HashInspection.vue"),
    meta: {
      title: "hashInspection",
      breadcrumb: hashInspectionBaseLink,
    },
  },
  {
    name: "threats",
    path: "/hash-inspection/:param",
    component: () => import("@/views/pages/HashInspection.vue"),
    meta: {
      title: "threatInspection",
      breadcrumb: hashInspectionBaseLink,
    },
  },
  {
    name: "eventInspection",
    path: "/event-inspection/:param",
    component: () =>
      import("@/views/pages/EventInspection/EventInspection.vue"),
    meta: {
      title: "eventInspection",
      breadcrumb: hashInspectionBaseLink,
    },
  },
  {
    name: "/policy",
    path: "/policy",
    meta: {
      title: "policyReview",
    },
    component: () => import("@/views/pages/Policy/Index.vue"),
    children: [...Policy],
  },
  {
    name: "/policies",
    path: "/policies",
    component: () => import("@/views/pages/Policies/Index.vue"),
    children: [...Policies],
  },
  {
    path: "/policies/policy-review",
    name: "/policies/policy-review",
    meta: {
      title: "policyReview",
    },
    component: () => import("@/views/pages/PolicyReview.vue"),
  },
  {
    path: "/policies/proposed-unique-blocks",
    name: "/policies/proposed-unique-blocks",
    meta: {
      title: "proposedUniqueBlocks",
      breadcrumbs: [
        {
          route: "/policies/policy-review",
          title: "policies",
        },
      ],
    },
    component: () => import("@/views/pages/proposedUniqueBlocks.vue"),
  },
  {
    path: "/policies/policy-change-checklist",
    name: "/policies/policy-change-checklist",
    meta: {
      title: "policyChangeChecklist",
      breadcrumb: "/policies/policy-change-checklist/draftreviews",
      default: {
        path: "/policies/policy-review",
        title: "policies",
      },
    },
    component: () => import("@/views/pages/policyChangeChecklist.vue"),
    children: [...PolicyChangeChecklist],
  },
  {
    path: "/saved-filters",
    name: "/saved-filters",
    component: () => import("@/views/pages/SavedFilters.vue"),
    meta: {
      title: "savedFilters",
    },
  },
  {
    path: "/saved-filters/:param",
    name: "/saved-filters/:param",
    component: () => import("@/views/pages/SavedFilters.vue"),
    meta: {
      title: "savedFilters",
    },
  },
  {
    path: "/alert-console",
    name: "alertConsole",
    component: () => import("@/views/pages/AlertConsole/Index.vue"),
    meta: {
      title: "alertConsole",
      breadcrumb: "/alert-console/unresolved",
    },
    children: [...AlertConsole],
  },
  {
    path: "/endpoints",
    name: "assets",
    component: () => import("@/views/pages/Assets/AssetIndex.vue"),
    meta: {
      title: "assets",
    },
    children: [...Endpoints],
  },

  {
    path: "/settings",
    name: "/settings",
    component: () => import("@/views/pages/Settings/Index.vue"),
    meta: {
      title: "settings",
    },
    children: [...Settings],
  },
  {
    path: "/profile",
    name: "/profile",
    component: () => import("@/views/pages/Profile.vue"),
    meta: {
      title: "User Profile",
    },
  },
  {
    path: "/cti",
    name: "/cti",
    component: () => import("@/views/pages/Cti.vue"),
    meta: {
      title: "CTI",
    },
  },
];
